import { ApiTags, rootApi } from '../../../../../services/rootApi';
import { IPayUHashRequest, IPayUHashResponse } from './models';

const TAG = ApiTags.Payment;

const payUApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getHash: builder.mutation<IPayUHashResponse, IPayUHashRequest>({
      query: (model) => ({
        url: '/Payments/PayU',
        method: 'POST',
        body: model
      }),
      invalidatesTags: [TAG]
    })

  })
})

export const {
  useGetHashMutation,
} = payUApi;